jQuery.noConflict();

(function (bootstrap, $) {
  var sections;
  var mwScroller;
  var contactPageMap;
  var contactPageContent;
  var isTouchDevice = Modernizr.touchevents;

  bootstrap.init = function () {
    el.window = $(window);
    el.documentElement = $(document);
    el.bodyElement = $("body");
    sections = $(".section:not(.section-no-min-height)");

    el.LAZY_LOAD_OPTIONS = {
      effect: "fadeIn",
      data_attribute: "src",
      skip_invisible: false,
      threshold: el.window.width() < 768 ? 1500 : 800, // on mobile, we allow a larger window for lazy loading
      // Transparent GIF as the placeholder
      placeholder: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    };

    $("img.lazy").lazyload(el.LAZY_LOAD_OPTIONS);

    AOS.init();
    // while the DOM is jumping around, we need to recalculate
    setTimeout(AOS.refresh, 1000);
    setTimeout(AOS.refresh, 3000);
    setTimeout(AOS.refresh, 6000);
    setTimeout(AOS.refresh, 10000);

    tns({
      container: ".pillars",
      loop: false,
      /*fixedWidth:200,*/
      autoWidth: false /* because we want 2 slides shown at once at times */,
      slideBy: 1,
      items: 1.2,
      //autoplay: true, // on the product detail page, autoplay seems to go haywire after dragging with mouse, so keep it off
      autoplayTimeout: 1000,
      autoplayHoverPause: true,
      controls: false,
      nav: false /* This turns off the nav dots */,
      autoplayButtonOutput: "",
      lazyload: false,
      mouseDrag: true,
      responsive: {
        2000: { items: 6.2 },
        1900: { items: 5.3 },
        1800: { items: 5.3 },
        1700: { items: 5.3 },
        1600: { items: 5.2 },
        1500: { items: 4.3 },
        1400: { items: 4.3 },
        1300: { items: 4.2 },
        1200: { items: 3.3 },
        1100: { items: 3.2 },
        1000: { items: 3.2 },
        900: { items: 2.4 },
        800: { items: 2.4 },
        700: { items: 2.4 },
        600: { items: 2.3 },
        500: { items: 2.2 },
        400: { items: 1.4 },
      },
      /*lazyloadSelector:'.inspired__image'*/
      /*center:true,*/
      /*mouseDrag:true*/ /* MouseDrag doesn't work very well when the items are anchor linked */
    });

    /*var pillarsSliderIsTransitioning = false;
		// bind function to event
		pillarsSlider.events.on('transitionStart', function() {
			pillarsSliderIsTransitioning = true;
		});

		// bind function to event
		pillarsSlider.events.on('transitionEnd', function() {
			pillarsSliderIsTransitioning = false;
		});

		$(".pillars").click(function() {
			if(!pillarsSliderIsTransitioning) {
				pillarsSlider.goTo('next');
			}
		});*/

    contactPageMap = $("#el-contact-map");
    contactPageContent = $("#contact-section-content");

    calculateWindowSize();
    setSectionsHeight();
    showCurrentDates();

    el.HistoryService.init();
    el.MouseCursor.init();
    el.HeaderView.init();
    el.MenuView.init();
    el.LogoView.init();
    el.KalitaView.init();
    el.RapidTappingView.init();
    el.SophiaWebsterView.init();
    el.FreyaView.init();
    el.OneWorldView.init();
    el.TheWeekDayView.init();
    el.QuoteView.init();
    el.OtherWorkView.init();
    el.TweetView.init();
    el.BusNycView.init();

    wireEvents();

    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
      var viewportmeta = document.querySelector('meta[name="viewport"]');
      if (viewportmeta) {
        viewportmeta.content = "width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0";
        document.body.addEventListener(
          "gesturestart",
          function () {
            viewportmeta.content = "width=device-width, minimum-scale=0.25, maximum-scale=1.6";
          },
          false,
        );
      }
    }
  };

  function wireEvents() {
    el.window.resize(
      _.debounce(function () {
        $.event.trigger("WINDOW_RESIZED_EVENT");
      }, 1000),
    );

    el.window.scroll(function () {
      var windowScrollTop = el.window.scrollTop();
      $.event.trigger("WINDOW_SCROLL_EVENT", [windowScrollTop]);
    });

    el.documentElement.on("WINDOW_RESIZED_EVENT", function () {
      calculateWindowSize();
      setSectionsHeight();
      calculateContactPageMapHeight();
    });
    calculateContactPageMapHeight();

    var homeSection = $("#home-section");
    var homeSectionHeight = homeSection.height();
    var homeSectionContent = $("#home-section-content");
    var takeALookTextAndArrow = $("#take-a-look-at-our-work, #scroll-down-indicator");

    takeALookTextAndArrow.click(function () {
      var firstVisibleSection = $("#home-section").nextAll(".section:visible").first();
      $("html, body").animate({ scrollTop: firstVisibleSection.offset().top }, 1000, "easeInOutExpo");
      takeALookTextAndArrow.delay(1001).fadeOut();
    });

    el.documentElement.on("WINDOW_SCROLL_EVENT", function (evt, windowScrollTop) {
      if (windowScrollTop > homeSectionHeight) {
        el.LogoView.pauseAnimations();
      } else {
        el.LogoView.resumeAnimations();
      }

      if (el.windowWidth < 768 || windowScrollTop > homeSectionHeight || isTouchDevice) {
        return;
      }

      var disappearDistance = 700;

      homeSectionContent.css({ y: Math.min(disappearDistance, windowScrollTop / 2) + "px" });
      homeSectionContent.css({ opacity: 1 - windowScrollTop / homeSectionHeight });
      takeALookTextAndArrow.css({ opacity: 1 - windowScrollTop / (homeSectionHeight / 3) });
    });

    var matthewWilliamsonSection = $("#mw-section");
    if (matthewWilliamsonSection.length > 0) {
      mwScroller = $("#mw-section");
      $(".mw-read-more-button").click(function () {
        calculateMWOffsetScroll();
      });

      var mwiPhoneNav = new el.DotNavigationView($, $("#mw-dots"), 3);
      mwiPhoneNav.init();
      mwiPhoneNav.setSelectedIndex(0);
      var mwScreenshots = $("#matthew-williamson-device-holder .slideshow-image");
      mwiPhoneNav.onSelectionChange(function (index) {
        mwScreenshots.removeClass("slideshow-image-visible");
        $(mwScreenshots.get(index)).addClass("slideshow-image-visible");
      });
    }

    // Lazy load the brand pillar lottie animations
    const element = document.querySelector("#team-section");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // If the element is in the viewport
        if (entry.isIntersecting) {
          // Do something with the element here

          // Stop observing the element
          observer.unobserve(entry.target);

          $(".pillar__img").each(function () {
            // Create a new element of the desired type
            const newElement = $("<lottie-player></lottie-player>");

            // Copy the attributes from the old element to the new one
            $.each(this.attributes, function () {
              if (this.specified) {
                newElement.attr(this.name, this.value);
              }
            });

            // Replace the old element with the new one
            $(this).replaceWith(newElement);
          });
        }
      });
    });

    // Start observing the element
    observer.observe(element);

    var googleMaps = $(".el-google-map");
    $.each(googleMaps, function (index, mapElement) {
      var mapView = new el.MapView(jQuery, mapElement);
      mapView.init();
    });
  }

  // The page is built ahead of time, so dates that must stay current are filled in here.
  // The build-time values in the markup act as the fallback.
  function showCurrentDates() {
    var now = new Date();

    $("[data-current-year]").each(function () {
      var offset = Number($(this).attr("data-current-year")) || 0;
      $(this).text(now.getFullYear() + offset);
    });

    $("[data-current-date]").text(now.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }));
  }

  function setSectionsHeight() {
    sections.css("min-height", el.windowHeight);
  }

  function calculateWindowSize() {
    el.windowHeight = el.window.height();
    el.windowWidth = el.window.width();
  }

  function calculateMWOffsetScroll() {
    if (mwScroller.hasClass("mw-section-is-offset")) {
      mwScroller.animate({ left: 0 });
      mwScroller.removeClass("mw-section-is-offset");
    } else {
      $("html, body").animate(
        {
          scrollTop: $("#mw-section").offset().top,
        },
        200,
      );

      $("img.mw-lazy").lazyload(el.LAZY_LOAD_OPTIONS);
      var iphoneScreenshot = $("#mw-iphone-screenshot");
      iphoneScreenshot.stop().css("top", 0);

      var iPhoneScreenshotImg = $("<img />");
      setTimeout(function () {
        imagesLoaded(iPhoneScreenshotImg, function () {
          setTimeout(function () {
            iphoneScreenshot.transit({ top: "-590%" }, 35000, function () {
              setTimeout(function () {
                iphoneScreenshot.css("top", 0);
              }, 2000);
            });
          }, 2000);
        });
      }, 4000);

      iPhoneScreenshotImg.attr("src", iphoneScreenshot.attr("data-src"));

      mwScroller.animate({ left: "-100%" });
      mwScroller.addClass("mw-section-is-offset");
    }
  }

  function calculateContactPageMapHeight() {
    contactPageMap.height(el.windowHeight - contactPageContent.outerHeight());
  }
})((window.el.Bootstrap = window.el.Bootstrap || {}), jQuery);

//as the page loads, call these scripts
jQuery(function () {
  // add all your scripts here
  el.Bootstrap.init();
});
